import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';

import PipelineNewForm from 'components/forms/pipelines/PipelineNewForm';

class PipelineNew extends React.Component {
  render() {
    const { intl, show, close, onSubmitParent } = this.props;
    const messages = intl.messages;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.create_pipeline}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PipelineNewForm onSubmitParent={onSubmitParent} />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(PipelineNew)));
